var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewEventParticipants',{attrs:{"me":_vm.$store.state.me,"slug":_vm.$route.params.slug,"isPaymentsEnabled":_vm.$store.state.billingTurnedOn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }